import { AudioManager } from "./AudioManaget";
import { UnitType } from "./units";

export var globals: {
    font: any
    panelColor: string
    audio: AudioManager
} = {
    font: null,
    panelColor: '',
    audio: null as unknown as AudioManager,
};

export type Faction = "neutral" | "player" | "green" | "blue"
export type UnitRegistry = { [key: string]: UnitType }

export function getFactionName(faction: Faction): string {
    switch (faction) {
        case "neutral": return "Neutral";
        case "player": return "Count Aznar";
        case "green": return "Duke Gynare";
        case "blue": return "Earl Moloch";
    }
}